import NextLink from 'next/link';

import { logTrackingEvent } from '@/utils/tracking';

const baseNavigationEvent = {
  event: 'navigation_click',
  navigation_type: 'footer_nav',
  nav_level: '1',
};

const logoWrapperBase =
  'inline-block mx-1.5 min-[576px]:mr-3 min-[576px]:ml-0 min-[992px]:mr-3 min-[992px]:ml-0 focus:outline-2 focus:outline-primary-400';

const sizeClasses = {
  default: 'w-[89px] min-[576px]:w-[80px] min-[992px]:w-[100px]',
  shortened: 'w-[71px] min-[576px]:w-[42px] min-[992px]:w-[62px]',
} as const;

type LogoLinkProps = {
  href?: string;
  trackingText?: string;
  size: 'default' | 'shortened';
  children: React.ReactNode;
};

export const LogoLink = ({ href, trackingText, size, children }: LogoLinkProps) => {
  const className = `${logoWrapperBase} ${sizeClasses[size]}`;

  if (!href) {
    return (
      <li className="flex items-center">
        <span className={className}>{children}</span>
      </li>
    );
  }

  return (
    <li className="flex items-center">
      <NextLink
        className={className}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() =>
          logTrackingEvent({
            ...baseNavigationEvent,
            click_text: trackingText,
            click_url: href,
          })
        }
      >
        {children}
      </NextLink>
    </li>
  );
};
